import React, { useEffect } from "react";
import "./MainScreen.css";
import { useLanguage } from "../Authentication/LanguageContext";
import GermanAppQr from "../GermanApp/GermanAppQr";

import appLogo from "../GermanApp/images/logo.png";

interface MainScreenProps {
  onStart: () => void;
}

const MainScreen: React.FC<MainScreenProps> = ({ onStart }) => {
  useEffect(() => {
    onStart();
  }, [onStart]);

  return (
    <div className="mainBackground">
      <div className="main-container">
        {/* Logo + Title */}
        <div className="main-title-wrapper">
          <img
            src={appLogo}
            alt="German A1-C2 App Logo"
            className="main-title-logo"
          />
          <h1 className="main-title">GERMAN A1-C2</h1>
        </div>

        {/* App QR Section */}
        <GermanAppQr
          iosStoreUrl="https://apps.apple.com/de/app/learn-german-a1-c2/id6746383285?l=en-GB"
          androidStoreUrl="https://play.google.com/store/apps/details?id=com.kugathaj.deutsch"
        />
      </div>
    </div>
  );
};

export default MainScreen;
